import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';

declare var axios;

if (environment.production) {
  enableProdMode();
}

axios.defaults.withCredentials = true;


platformBrowserDynamic().bootstrapModule(AppModule)
  .catch(err => console.error(err));

